import React from 'react';
import ReusableTabs from '../../../pages/ReusableTabs';
import UploadSection from './Sections/UploadSection';
import LibrarySection from './Sections/LibrarySection';
import AuditSection from './Sections/AuditSection';

const EngineeringPanel = () => {
  const tabs = [
    { label: 'UPLOAD', component: <UploadSection /> },
    { label: 'LIBRARY', component: <LibrarySection /> },
    { label: 'AUDITS', component: <AuditSection /> },
  ];

  return (
    <div>
      <ReusableTabs
        tabs={tabs}
        defaultTab={0}
        panelStyles={{ padding: '16px' }}
      />
    </div>
  );
};

export default EngineeringPanel;